import { type JSX, useCallback } from 'react';

import { createFileRoute, Outlet } from '@tanstack/react-router';

import { SchoolProvider } from '@/features/home-manager';
import { learningPathSearchParamsSchema, type LearningPathSearchParams } from '@/features/learning-path';
import { useNavigateMerge } from '@/hooks/useNavigateMerge';
import { requireAccess } from '@/permissions';

export const Route = createFileRoute('/trilha-de-aprendizagem')({
  beforeLoad: requireAccess('view:learning_path'),
  validateSearch: (search): LearningPathSearchParams => learningPathSearchParamsSchema.parse(search),
  component: LearningPathLayout,
});

function LearningPathLayout(): JSX.Element {
  const { escola } = Route.useSearch();
  const navigate = useNavigateMerge();

  const handleSchoolIdChange = useCallback(
    (schoolId: string) => {
      void navigate({
        to: '.',
        search: { escola: Number(schoolId) },
        replace: true,
      });
    },
    [navigate]
  );

  return (
    <SchoolProvider
      schoolId={typeof escola === 'number' ? String(escola) : null}
      onSchoolIdChange={handleSchoolIdChange}>
      <Outlet />
    </SchoolProvider>
  );
}
